<template>
  <Row>
    <Modal v-model="showHelp" title="友情提示">
    <p>总线索量：指已联系、有需求、已到店、已签单、已放弃的数据</p>
    <p>未联系：指未曾对新客资进行联系、没有添加回访记录的数据</p>
    <p>已联系：指通过电话/微信/短信等方式与客户取得联系，同时在系统添加了回访记录（不论有效与否）</p>
    <p>有需求：指已经与客户取得联系，客户想了解服务内容、套餐价格、分店信息、优惠活动等视为有需求线索</p>
    <p>已到店：指客户亲自到店了解服务内容、套餐价格、分店信息、优惠活动等，同时在系统添加回访记录时选择已到店的数据</p>
    <p>已签单：指线下已签预定单合同，系统上创建预定单的数据</p>
    </Modal>
    <Col span="12"
      ><Card style="width: 98%" title="客户概况">
        <Row style="padding-right: 10px">
          <Form ref="formValidate" :model="listQuery" :label-width="60">
            <Row>
              <Col span="8">
                <FormItem label="门店">
                  <Select
                    ref="select_store"
                    v-model="listQuery.store_id"
                    placeholder="请选择门店"
                    style="90%"
                    @on-change="selectStore"
                  >
                    <Option
                      v-for="item in storeList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>

              <Col span="8">
                <FormItem label="部门">
                  <Select
                    v-model="listQuery.department_id"
                    placeholder="请选择部门"
                    style="90%"
                    @on-change="selectDepartment"
                  >
                    <Option
                      v-for="item in departmentList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem label="顾问">
                  <Select
                    v-model="listQuery.agent_id"
                    placeholder="请选择顾问"
                    style="90%"
                  >
                    <Option
                      v-for="item in agentList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="16">
                <FormItem
                  label="分配至门店时间"
                  class="mb-10"
                  :label-width="110"
                >
                  <DatePicker
                    type="date"
                    v-model="defaultStartEntryTime"
                    placeholder="请选择录入开始时间"
                    style="width: 45%"
                    :options="startEntryTime"
                    format="yyyy-MM-dd"
                    @on-change="startTimeChange($event, 1)"
                  ></DatePicker>
                  <span> 至 </span>
                  <DatePicker
                    type="date"
                    v-model="defaultEndEntryTime"
                    placeholder="请选择录入结束时间"
                    style="width: 45%"
                    :options="endEntryTime"
                    format="yyyy-MM-dd"
                    @on-change="endTimeChange($event, 1)"
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col span="8">
                <Button
                  class="item"
                  type="primary"
                  icon="ios-search"
                  @click="apiGetIndex([1])"
                  >查询</Button
                >
                <Button class="item" @click="emptyFilter(1)">清空筛选</Button>
              </Col>
            </Row>
          </Form>
        </Row>
        <Spin size="large" v-if="todoList == null" fix></Spin>
        <Row v-if="todoList != null">
          <Col span="5">
            <img
              src="/static/icon-未联系.png"
              alt="未联系"
              class="toolbar"
              @click="onSelectToolbar('onConnect')"
            />
            <p class="title" @click="onSelectToolbar('onConnect')">
              <span class="num">{{ todoList.onConnect }}</span
              >未联系
            </p>
          </Col>
          <Col span="5">
            <img
              src="/static/icon-已联系.png"
              alt="已联系"
              class="toolbar"
              @click="onSelectToolbar('connect')"
            />
            <p class="title" @click="onSelectToolbar('connect')">
              <span class="num">{{ todoList.connect }}</span
              >已联系
            </p>
          </Col>
          <Col span="5">
            <img
              src="/static/icon-有需求.png"
              alt="有需求"
              class="toolbar"
              @click="onSelectToolbar('need')"
            />
            <p class="title" @click="onSelectToolbar('need')">
              <span class="num">{{ todoList.need }}</span
              >有需求
            </p>
          </Col>
          <!-- <Col span="4">
            <img
              src="/static/icon-有意向.png"
              alt="有意向"
              class="toolbar"
              @click="onSelectToolbar('intention')"
            />
            <p class="title" @click="onSelectToolbar('intention')">
              <span class="num">{{ todoList.intention }}</span
              >有意向
            </p>
          </Col> -->
          <Col span="5">
            <img
              src="/static/icon-已到店.png"
              alt="已到店"
              class="toolbar"
              @click="onSelectToolbar('arrive')"
            />
            <p class="title" @click="onSelectToolbar('arrive')">
              <span class="num">{{ todoList.arrive }}</span
              >已到店
            </p>
          </Col>
          <Col span="4">
            <img
              src="/static/icon-已签单.png"
              alt="已签单"
              class="toolbar"
              @click="onSelectToolbar('sign')"
            />
            <p class="title" @click="onSelectToolbar('sign')">
              <span class="num">{{ todoList.sign }}</span
              >已签单
            </p>
          </Col>
        </Row>
        <Row>
          <Col style="text-align: right">
            <span>数据更新时间：{{ updateTime }}</span>
          </Col>
        </Row>
      </Card></Col
    >
    <Col span="12"
      ><Card style="width: 98%">
        <p slot="title" @click="selectHelp()">
          概况漏斗
          <Icon type="md-help-circle" size="20" @click="selectHelp()" />
         <span style="color:red"> (分配至门店时间默认为本月的数据，查询其它时间请扩选时间范围)</span>
        </p>
        <Row>
          <Form ref="formValidate" :model="listQuery_funnel" :label-width="60">
            <Row>
              <Col span="8">
                <FormItem label="门店">
                  <Select
                    v-model="listQuery_funnel.store_id"
                    placeholder="请选择门店"
                    style="90%"
                    @on-change="selectFunnelStore"
                  >
                    <Option
                      v-for="item in storeList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>

              <Col span="8">
                <FormItem label="部门">
                  <Select
                    v-model="listQuery_funnel.department_id"
                    placeholder="请选择部门"
                    style="90%"
                    @on-change="selectFunnelDepartment"
                  >
                    <Option
                      v-for="item in departmentFunnelList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem label="顾问">
                  <Select
                    v-model="listQuery_funnel.agent_id"
                    placeholder="请选择顾问"
                    style="90%"
                  >
                    <Option
                      v-for="item in agentFunnelList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="16">
                <FormItem
                  label="分配至门店时间"
                  class="mb-10"
                  :label-width="110"
                >
                  <DatePicker
                    type="date"
                    placeholder="请选择录入开始时间"
                    style="width: 45%"
                    :options="startEntryTime"
                    v-model="defaultFunnelStartEntryTime"
                    format="yyyy-MM-dd"
                    @on-change="startTimeChange($event, 1)"
                  ></DatePicker>
                  <span> 至 </span>
                  <DatePicker
                    type="date"
                    placeholder="请选择录入结束时间"
                    style="width: 45%"
                    v-model="defaultFunnelEndEntryTime"
                    :options="endEntryTime"
                    format="yyyy-MM-dd"
                    @on-change="endTimeChange($event, 1)"
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col span="8">
                <Button
                  class="item"
                  type="primary"
                  icon="ios-search"
                  @click="apiGetIndex([2])"
                  >查询</Button
                >
                <Button class="item" @click="emptyFilter(2)">清空筛选</Button>
              </Col>
            </Row>
          </Form>
        </Row>
        <Spin size="large" v-if="funnelData == null" fix></Spin>
        <v-chart class="chart" :option="option" />
        <Row>
          <Col style="text-align: right" span="24">
            <span>数据更新时间：{{ updateTime }}</span>
          </Col>
        </Row>
      </Card></Col
    >
  </Row>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { FunnelChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  ToolboxComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";
import dropCheckBox from "@/commonTmp/dropCheckBox"; //多选下拉框
use([
  CanvasRenderer,
  FunnelChart,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
]);

export default {
  name: "index",
  components: {
    VChart,
    dropCheckBox,
  },
  provide: {
    [THEME_KEY]: "light",
  },
  data() {
    return {
      indexData: [],
      toolbarUrl: null,
      updateTime: "",
      storeList: [],
      showHelp: false,
      departmentList: [
        {
          id: 0,
          name: "全部部门",
        },
      ],
      agentList: [
        {
          id: 0,
          name: "全部顾问",
        },
      ],
      departmentFunnelList: [
        {
          id: 0,
          name: "全部部门",
        },
      ],
      agentFunnelList: [
        {
          id: 0,
          name: "全部顾问",
        },
      ],
      updateFunnelTime: "2022-03-21",
      defaultStartEntryTime: util.getMonthStart(),
      defaultEndEntryTime: util.getNowFormatDate(),
      defaultFunnelStartEntryTime: util.getMonthStart(),
      defaultFunnelEndEntryTime: util.getNowFormatDate(),
      startEntryTime: {}, //开始日期设置
      endEntryTime: {}, //结束日期设置
      funnelData: null,
      todoList: null,
      signStoreCheckedShowValue: window.agent_info.store_name,
      listQuery: {
        store_id: 0,
        type: 1,
        department_id: 0,
        agent_id: 0,
        distribute_start_time: util.getMonthStart(),
        distribute_end_time: util.getNowFormatDate(),
      },

      listQuery_funnel: {
        store_id: 0,
        type: 2,
        department_id: 0,
        agent_id: 0,
        distribute_start_time: util.getMonthStart(),
        distribute_end_time: util.getNowFormatDate(),
      },
      option: {},
    };
  },
  created() {
    this.apiIndexStore([1, 2]);
    // this.apiGetIndex([1, 2]);
  },
  methods: {
    selectHelp() {
      this.showHelp = true;
    },
    selectStore(value) {
      this.apiIndexDepartment(value, 1);
    },
    selectDepartment(value) {
      this.apiIndexAgent(value, this.listQuery.store_id, 1);
    },
    selectFunnelStore(value, type) {
      this.apiIndexDepartment(value, 2);
    },
    selectFunnelDepartment(value, type) {
      this.apiIndexAgent(value, this.listQuery_funnel.store_id, 2);
    },
    emptyFilter(selectType) {
      if (selectType == 1) {
        this.listQuery = {
          store_id: "all",
          type: 1,
          department_id: 0,
          agent_id: 0,
          distribute_start_time: util.getMonthStart(),
          distribute_end_time: util.getNowFormatDate(),
        };
        this.departmentList = [
          {
            id: 0,
            name: "全部部门",
          },
        ];
        this.agentList = [];
        this.updateFunnelTime = "";
        this.$refs.select_store.clear();
      } else {
        this.listQuery_funnel = {
          store_id: "all",
          type: 1,
          department_id: 0,
          agent_id: 0,
          distribute_start_time: util.getMonthStart(),
          distribute_end_time: util.getNowFormatDate(),
        };
        this.departmentFunnelList = [
          {
            id: 0,
            name: "全部部门",
          },
        ];
        this.agentFunnelList = [];
        this.updateFunnelTime = "";
      }

      this.apiGetIndex();
    },
    apiGetIndex(selectTypes) {
      var params = {};
      if (selectTypes.indexOf(1) != -1) {
        this.todoList = null;
        this.listQuery.distribute_start_time = util.dateFormat(
          this.defaultStartEntryTime
        );
        this.listQuery.distribute_end_time = util.dateFormat(
          this.defaultEndEntryTime
        );
        params = this.listQuery;
      } else if (selectTypes.indexOf(2) != -1) {
        this.funnelData = null;
        this.listQuery_funnel.distribute_start_time = util.dateFormat(
          this.defaultFunnelStartEntryTime
        );
        this.listQuery_funnel.distribute_end_time = util.dateFormat(
          this.defaultFunnelEndEntryTime
        );
        params = this.listQuery_funnel;
      }

      serve
        .fetchGet(api.index, params)
        .then((data) => {
          console.log(data);
          if (selectTypes.indexOf(1) != -1) {
            this.todoList = data.list;
            this.updateTime = data.updatetime;
            this.toolbarUrl = data.url;
          }
          if (selectTypes.indexOf(2) != -1) {
            this.funnelData = data.funnel;
            this.updateFunnelTime = data.updatetime;
            this.option = {
              title: {
                text: "",
              },
              tooltip: {
                trigger: "item",
                formatter: (obj) => {
                  console.log("obj", obj);
                  return (
                    obj.name +
                    " " +
                    obj.data.value +
                    "，" +
                    obj.data.ratio +
                    "%"
                  );
                },
              },
              toolbox: {
                feature: {
                  dataView: { show: false },
                  restore: { show: false },
                  saveAsImage: { show: false },
                },
              },
              legend: {
                data: [
                  "总线索量",
                  // "已放弃",
                  "已联系",
                  "有需求",
                  // "有意向",
                  "已到店",
                  "已签单",
                ],
              },
              series: [
                {
                  sort: "none", //不排序，按照给定数据的顺序
                  name: "漏斗图",
                  type: "funnel",
                  left: "10%",
                  width: "70%",
                  minSize: "5%",
                  label: {
                    formatter: (obj) => {
                      console.log("obj", obj);
                      return obj.name + " " + obj.data.value;
                    },
                    textStyle: {
                      color: "#000000",
                    },
                  },
                  labelLine: {
                    show: false,
                  },
                  itemStyle: {
                    opacity: 0.7,
                  },
                  emphasis: {
                    label: {
                      position: "inside",
                      formatter: (obj) => {
                        console.log("obj", obj);
                        return (
                          obj.name +
                          " " +
                          obj.data.value +
                          "，" +
                          obj.data.ratio +
                          "%"
                        );
                      },
                    },
                  },
                  data: [
                    {
                      value: this.funnelData.counts.num,
                      ratio: this.funnelData.counts.ratio,
                      name: "总线索量",
                    },
                    // {
                    //   value: this.funnelData.giveUp.num,
                    //   ratio: this.funnelData.giveUp.ratio,
                    //   name: "已放弃",
                    // },
                    {
                      value: this.funnelData.connect.num,
                      ratio: this.funnelData.connect.ratio,

                      name: "已联系",
                    },
                    {
                      value: this.funnelData.need.num,
                      ratio: this.funnelData.need.ratio,
                      name: "有需求",
                    },

                    // {
                    //   value: this.funnelData.intention.num,
                    //   ratio: this.funnelData.intention.ratio,
                    //   name: "有意向",
                    // },

                    {
                      value: this.funnelData.arrive.num,
                      ratio: this.funnelData.arrive.ratio,
                      name: "已到店",
                    },
                    {
                      value: this.funnelData.sign.num,
                      ratio: this.funnelData.sign.ratio,
                      name: "已签单",
                    },
                  ],
                },
              ],
            };
            this.chart.setOption(this.option);
          }
        })
        .catch((error) => {});
    },
    onSelectToolbar(selectType) {
      console.log("onSelectToolbar", selectType);
      if (this.toolbarUrl == null) {
        return;
      }
      this.$router.push({
        path: this.toolbarUrl,
      });
    },
    // 门店
    apiIndexStore(selectTypes) {
      serve.fetchGet(api.indexStore, {}).then((data) => {
        this.storeList = data;
        if (data != null && data.length > 1) {
          this.storeList.unshift({
            id: "all",
            name: "全部门店",
          });
          this.apiGetIndex([1, 2]);
        } else if (data.length == 1) {
          if (selectTypes.indexOf(1) != -1) {
            this.listQuery.store_id = data[0].id;
            this.apiIndexDepartment(this.listQuery.store_id, 1);
          }
          if (selectTypes.indexOf(2) != -1) {
            this.listQuery_funnel.store_id = data[0].id;
            this.apiIndexDepartment(this.listQuery_funnel.store_id, 2);
          }
        }
      });
    },
    /**
     * @selectType 1 是工作台 2 漏斗
     */
    apiIndexDepartment(store_id, selectType) {
      if (store_id > 0) {
        serve
          .fetchGet(api.indexDepartment, { store_id: store_id })
          .then((data) => {
            if (selectType == 1) {
              this.departmentList = data;
              if (data != null && data.length == 1) {
                this.listQuery.department_id = data[0].id;
                this.apiIndexAgent(
                  this.listQuery.department_id,
                  this.listQuery.store_id,
                  1
                );
              } else {
                this.departmentList.unshift({
                  id: 0,
                  name: "全部部门",
                });
                this.apiGetIndex([1]);
              }
            } else {
              this.departmentFunnelList = data;
              if (data != null && data.length == 1) {
                this.listQuery_funnel.department_id = data[0].id;
                this.apiIndexAgent(
                  this.listQuery_funnel.department_id,
                  this.listQuery_funnel.store_id,
                  2
                );
              } else {
                this.departmentFunnelList.unshift({
                  id: 0,
                  name: "全部部门",
                });
                this.apiGetIndex([2]);
              }
            }
          });
      }
    },
    apiIndexAgent(department_id, store_id, selectType) {
      if (department_id > 0 && store_id > 0) {
        serve
          .fetchGet(api.indexAgent, {
            department_id: department_id,
            store_id: store_id,
          })
          .then((data) => {
            if (selectType == 1) {
              this.agentList = data;
              if (data != null && data.length == 1) {
                this.listQuery.agent_id = data[0].id;
              } else {
                this.agentList.unshift({
                  id: 0,
                  name: "全部顾问",
                });
              }
              this.apiGetIndex([1]);
            } else {
              this.agentFunnelList = data;
              if (data != null && data.length == 1) {
                this.listQuery_funnel.agent_id = data[0].id;
              } else {
                this.agentFunnelList.unshift({
                  id: 0,
                  name: "全部顾问",
                });
              }
              this.apiGetIndex([2]);
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.chart {
  height: 400px;
  width: 100%;
}
.toolbar {
  width: 60px;
  text-align: center;
}
.num {
  font-size: 20pt;
  font-weight: bold;
  padding-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Crm/UserManagement/funnel.vue